import { isCleartrip } from '@/src/utils/generalUtils/isCleartrip'

/**
 * Returns the wallet channel value when applicable.
 * Safe for server and client (no next/headers).
 */
export const getWalletChannel = (): string | null => {
    return isCleartrip() ? null : 'Fly'
}
